import React, { useState, useEffect } from 'react';
import Editor from '@monaco-editor/react';

const CodeEditor = () => {
  const [code, setCode] = useState('');
  const [file, setFile] = useState(null);
  const [language, setLanguage] = useState('javascript');

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
    }
  };

  useEffect(() => {
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setCode(e.target.result);
      };
      reader.readAsText(file);

      const ext = file.name.split('.').pop();
      const extToLang = {
        js: 'javascript',
        jsx: 'javascript',
        ts: 'typescript',
        tsx: 'typescript',
        html: 'html',
        css: 'css',
        py: 'python',
        dart: 'dart',
      };

      setLanguage(extToLang[ext] || 'javascript');
    }
  }, [file]);

  const options = {
    selectOnLineNumbers: true,
    automaticLayout: true,
    formatOnType: true,
    formatOnPaste: true,
    wordWrap: 'on',
    minimap: { enabled: false },
    fontSize: 14,
    quickSuggestions: { other: true, comments: true, strings: true },
    suggestOnTriggerCharacters: true,
    tabCompletion: 'on',
    acceptSuggestionOnEnter: 'on',
  };

  return (
   
    <div style={{ height: "100vh", padding: "20px" }}>
      <Editor
 height="400px"
  defaultLanguage="javascript"
  language={language}
  value={code}
  onChange={(value) => setCode(value)}
  options={options}
  theme="vs-light"
/>
</div>
  );
};

const App = () => (
  <div>
    <h2>Monaco Editor (Auto Suggest)</h2>
    <CodeEditor />
  </div>
);

export default App;
